function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 12h-3v12H9V12H7V8h2V5c0-2 1-5 5-5h3v4h-2c-1 0-1 0-1 1v3h3z",
  fill: "#8781bd"
});

function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTcgMTJoLTN2MTJoLTV2LTEyaC0ydi00aDJ2LTNjMC0yIDEtNSA1LTVoM3Y0aC0yYy0xIDAtMSAwLTEgMXYzaDN6IiBmaWxsPSIjODc4MWJkIi8+PC9zdmc+";
export { SvgFacebookLogo as ReactComponent };